import { render, staticRenderFns } from "./DeadPlateGrid.vue?vue&type=template&id=668812f6&scoped=true"
import script from "./DeadPlateGrid.vue?vue&type=script&lang=js"
export * from "./DeadPlateGrid.vue?vue&type=script&lang=js"
import style0 from "./DeadPlateGrid.vue?vue&type=style&index=0&id=668812f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668812f6",
  null
  
)

export default component.exports